export default __webpack_public_path__ + "static/media/nftLevel3Thumb.4bfba645.jpg";